import { api } from '../api';
import type { PaginationParams, PaginatedResponse } from '@/types/common';
import type { RecipeFavourite } from '@/types/recipe';

export interface FavouriteStatusResponse {
  isFavourited: boolean;
}

export const recipeFavouriteRequests = {
  list: (params?: PaginationParams) => {
    const sp = new URLSearchParams();
    if (params?.page != null) sp.set('page', params.page.toString());
    if (params?.limit != null) sp.set('limit', params.limit.toString());
    const qs = sp.toString();
    return api.get<PaginatedResponse<RecipeFavourite>>(`/recipe-favourites${qs ? `?${qs}` : ''}`);
  },

  status: (recipeId: number) =>
    api.get<FavouriteStatusResponse>(`/recipe-favourites/${recipeId}/status`),

  add: (recipeId: number) =>
    api.post<RecipeFavourite>(`/recipe-favourites/${recipeId}`),

  remove: (recipeId: number) =>
    api.delete<{ deleted: boolean }>(`/recipe-favourites/${recipeId}`),
};
